import React from "react";
import { IdsContext } from "./IdsContext";
import styles from "./style.module.scss";

export default function IdsSwitch() {
  const idsContext = React.useContext(IdsContext);
  if (!idsContext) {
    throw new Error("IdsContext must be used inside an IdsProvider");
  }
  const { showCodes, toggleShowCodes } = idsContext;

  return (
    <label className={styles.switch}>
      <input type="checkbox" checked={showCodes} onChange={toggleShowCodes} />
      <span className={styles.slider}></span>
      <span className={styles.labelText}>Codes</span>
    </label>
  );
}
